@if (filterType() === 'sidenav') {
	<mat-sidenav-container>
		<mat-sidenav #sidenav mode="side" [disableClose]="true" [opened]="!closed()" [hidden]="hideFilters()" class="dark-theme">
			<div class="filter-list" nhaTest="filter-sidebar">
				<div class="filter-closer">
					<button nhaTest="filters-close" nhaTest="filter-toggle" mat-button (click)="setClosed()">
						<mat-icon>clear</mat-icon>
						<span>Filters</span>
					</button>
					@if (canSwitchView()) {
						<button mat-button (click)="changeFilterType('chip')" matTooltip="Show filters in header">
							<mat-icon>swap_horiz</mat-icon>
							Switch View
						</button>
					}
				</div>

				@if (loaded()) {
					<div class="filter-group">
						<ng-content select="[filters-before]"></ng-content>

						@if (hasGroups()) {
							@for (block of orderedFilterBlocks(); track block.key) {
								<div [ngClass]="{ grouped: block.isGroup }">
									@if (block.isGroup) {
										<div class="group-label">
											<button mat-button (click)="toggleGroupExpand(block.groupTitle)" nhaTest="filter-header">
												{{ block.groupTitle }}

												<mat-icon iconPositionEnd>
													{{ expandedGroups().includes(block.groupTitle) ? 'remove' : 'add' }}
												</mat-icon>
											</button>
										</div>
									}

									@if (!block.isGroup || expandedGroups().includes(block.groupTitle)) {
										@for (filter of getFiltersByKey(block.key, block.isGroup); track filter.key) {
											<div class="filter-container">
												<nha-filter
													[key]="key()"
													[filterKey]="filter.key"
													[filter]="filter.value"
													[counts]="counts()"
													[custom]="getCustomFilter(filter.key)"
													nhaTest
												></nha-filter>
											</div>
										}
									}
								</div>
							}
						} @else {
							@for (filter of visibleFilters(); track filter.key) {
								<div class="filter-container">
									<nha-filter
										[key]="key()"
										[filterKey]="filter.key"
										[filter]="filter.value"
										[counts]="counts()"
										[custom]="getCustomFilter(filter.key)"
										nhaTest
									></nha-filter>
								</div>
							}
						}

						<ng-content select="[filters-after]"></ng-content>
					</div>
				}
			</div>
		</mat-sidenav>

		<mat-sidenav-content>
			<div class="filter-content">
				<div class="filter-launcher">
					@if (closed()) {
						<div matTooltip="Filters Locked" [matTooltipDisabled]="!locked()">
							<button nhaTest="filters-open" nhaTest="filter-toggle" mat-button (click)="setClosed()" [disabled]="locked()">
								<mat-icon>filter_list</mat-icon>
								<span>Filters</span>
							</button>
						</div>
					}

					<div class="filter-selections">
						@for (filter of selectedFilters(); track filter.key) {
							<nha-selected-filter-chip
								[key]="key()"
								[filterKey]="filter.key"
								[filter]="filter.value"
								(deselect)="deselectFilterItem($event.filterKey, $event.item)"
								(deselectAll)="deselectAllFilterItems($event)"
							></nha-selected-filter-chip>
						}
					</div>

					<ng-container [ngTemplateOutlet]="filterLauncherAfter"></ng-container>
				</div>

				<div class="filter-results">
					<ng-container [ngTemplateOutlet]="filterResults"></ng-container>
				</div>
			</div>
		</mat-sidenav-content>
	</mat-sidenav-container>
} @else {
	<div class="filter-chips">
		<div class="filter-chip-header">
			@if (!locked()) {
				<button mat-icon-button matTooltip="Show filter list" (click)="changeFilterType('sidenav')" nhaTest="filters-to-sidenav">
					<mat-icon>filter_list</mat-icon>
				</button>
			} @else {
				<mat-icon matTooltip="Filters locked">lock</mat-icon>
			}

			<div class="filters-content">
				@if (hasGroups()) {
					@for (block of orderedFilterBlocks(); track block.key) {
						@if (block.isGroup) {
							@let filterGroups = getFiltersByKey(block.key, block.isGroup);

							<nha-filter-chip-group
								[key]="key()"
								[groupTitle]="block.groupTitle"
								[filters]="filterGroups"
								[counts]="counts()"
							></nha-filter-chip-group>
						} @else {
							@let singleFilter = getFiltersByKey(block.key, block.isGroup)[0];

							<nha-filter-chip [key]="key()" [filterKey]="singleFilter.key" [filter]="singleFilter.value" [counts]="counts()"></nha-filter-chip>
						}
					}
				} @else {
					@for (filter of visibleFilters(); track filter.key) {
						<nha-filter-chip [key]="key()" [filterKey]="filter.key" [filter]="filter.value" [counts]="counts()"></nha-filter-chip>
					}
				}
			</div>

			<div class="filter-chip-after">
				<ng-container [ngTemplateOutlet]="filterLauncherAfter"></ng-container>
			</div>
		</div>

		<div class="filter-chip-results">
			<ng-container [ngTemplateOutlet]="filterResults"></ng-container>
		</div>
	</div>
}

<ng-template #filterResults>
	<ng-content></ng-content>
</ng-template>

<ng-template #filterLauncherAfter>
	<ng-content select="[filters-launcher-after]"></ng-content>
</ng-template>
